import React from 'react'
import { useTranslation } from 'react-i18next'

import { Section, Interpunct } from 'components/BusinessCard/components/StyledComponents'
import { H6, P } from '@PipelineDeals/shared-react-components'

import { useBusinessCard } from 'components/BusinessCard/context'
import { formatDate } from 'utils/date'

const CreatedUpdated = () => {
  const { t } = useTranslation()
  const { cardMeta: { showOnlyFields }, resource } = useBusinessCard()

  const showCreated = showOnlyFields.includes('created') || showOnlyFields.includes('created_at')
  const showUpdated = showOnlyFields.includes('updated') || showOnlyFields.includes('updated_at')

  if (!showCreated && !showUpdated) return null

  return (
    <Section>
      <H6>
        {showCreated && t('businessCard.labels.added')}{showCreated && showUpdated && ' / '}{showUpdated && t('businessCard.labels.updated')}
      </H6>
      <P>
        {showCreated && formatDate(resource.created_at)}{showCreated && showUpdated && <>&nbsp;<Interpunct />&nbsp;</>}{showUpdated && formatDate(resource.updated_at)}
      </P>
    </Section>
  )
}

export default CreatedUpdated
